// extracted by mini-css-extract-plugin
export default {"popover-icon":"ioBcplUUTBG24H0dRe2X","popoverIcon":"ioBcplUUTBG24H0dRe2X"};